<template>
  <div>
    <h1>
      Uploads
      <span v-if="computedItems && computedItems.length > 0"
        >&#160;({{ computedItems.length }})</span
      >
    </h1>
    <v-data-table
      v-if="computedItems && computedItems.length > 0"
      :headers="headers"
      :items="computedItems"
      :pagination.sync="pagination"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr :class="props.item.archived ? 'uploadItemArchived' : ''">
          <td>
            <v-btn small @click="download(props.item)">{{
              props.item.id
            }}</v-btn>
          </td>
          <td>
            <FileGql :file="props.item.file" v-if="props.item.file" />
            <EntityZ :entity="props.item.entity" v-if="props.item.entity" />
          </td>
          <td>{{ props.item.description }}</td>
          <td>{{ props.item.type }}</td>
          <td>{{ props.item.visible }}</td>
          <td>
            <span
              :class="props.item.virusCheck.styleClass"
              v-if="props.item.virusCheck"
              >{{ props.item.virusCheck.body }}</span
            >
          </td>
          <td>
            <EntityZ
              :entity="props.item.user"
              v-if="props.item.user"
              format="system"
            />
          </td>
          <td>
            {{ props.item.timestamp | formatTime }}
            <v-btn
              v-if="$keycloak.hasRealmRole('root')"
              @click="virusScan(props.item)"
              >virus scan</v-btn
            >
          </td>
        </tr>
      </template>
    </v-data-table>
    <v-alert :value="computedItems && computedItems.length == 0" type="info"
      >No uploads found</v-alert
    >
    <v-progress-circular indeterminate color="info" v-if="!computedItems" />
  </div>
</template>

<script>
import UPLOAD_ENTITIES from "@/graphql/document/UploadEntities";
import UPLOAD_ENTITY_SIGNED_URL from "@/graphql/document/UploadEntitySignedUrl";
import UPLOAD_FILES from "@/graphql/document/UploadFiles";
import UPLOAD_FILE_SIGNED_URL from "@/graphql/document/UploadFileSignedUrl";
import SCAN_UPLOAD from "@/graphql/document/ScanUpload";
import EntityZ from "@/components/link/EntityZ";
import FileGql from "@/components/link/FileGql";
export default {
  name: "Uploads",
  metaInfo() {
    return {
      title: "Uploads",
      titleTemplate: "%s - Document - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  apollo: {
    uploadEntities: {
      query: UPLOAD_ENTITIES,
      variables() {
        return {
          date: this.computedDate
        };
      },
      fetchPolicy: "cache-and-network"
    },
    uploadFiles: {
      query: UPLOAD_FILES,
      variables() {
        return {
          date: this.computedDate
        };
      },
      fetchPolicy: "cache-and-network"
    }
  },
  components: {
    EntityZ,
    FileGql
  },
  computed: {
    computedItems() {
      if (!this.uploadFiles || !this.uploadEntities) {
        return undefined;
      }
      const items = [];
      if (this.uploadFiles) {
        this.uploadFiles.forEach((f) => {
          items.push({
            id: f.id,
            uploadId: f.upload.id,
            virusCheck: this.selectVirusCheck(f.upload.virus),
            type: "file",
            file: f.file,
            description: f.uploadDescription.body,
            user: f.user,
            visible: !f.hide,
            timestamp: f.timestamp
          });
        });
      }
      if (this.uploadEntities) {
        this.uploadEntities.forEach((e) => {
          items.push({
            id: e.id,
            uploadId: e.upload.id,
            virusCheck: this.selectVirusCheck(e.upload.virus),
            type: "entity",
            entity: e.entity,
            description: e.uploadDescription.body,
            user: e.user,
            visible: !e.hide,
            timestamp: e.timestamp
          });
        });
      }
      // items.sort((a, b) => a.id - b.id);
      return items;
    },
    computedDate() {
      return this.$route.query.date
        ? this.$route.query.date.substring(0, 4) +
            "-" +
            this.$route.query.date.substring(4, 6) +
            "-" +
            this.$route.query.date.substring(6, 8)
        : new Date().toISOString().substr(0, 10);
    }
  },
  data() {
    return {
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Reference",
          value: "file.id"
        },
        {
          text: "Description",
          value: "description"
        },
        {
          text: "Type",
          value: "type"
        },
        {
          text: "Visible to client",
          value: "visible"
        },
        {
          text: "Virus",
          value: "virusCheck.body"
        },
        {
          text: "User",
          value: "user.name"
        },
        {
          text: "time",
          value: "timestamp"
        }
      ],
      pagination: {
        rowsPerPage: -1,
        sortBy: "timestamp"
      }
    };
  },
  methods: {
    async virusScan(upload) {
      await this.$apollo.mutate({
        mutation: SCAN_UPLOAD,
        variables: { id: upload.uploadId },
        refetchQueries: [
          {
            query: UPLOAD_ENTITIES,
            variables: { date: this.computedDate }
          },
          {
            query: UPLOAD_FILES,
            variables: { date: this.computedDate }
          }
        ]
      });
    },
    selectVirusCheck(virusCheckId) {
      let virusCheck = {};
      virusCheck.virusCheckId = virusCheckId;
      switch (virusCheckId) {
        case 0:
          virusCheck.body = "unchecked";
          break;
        case 1:
          virusCheck.body = "failed";
          break;
        case 2:
          virusCheck.body = "passed";
          break;
        case 3:
          virusCheck.body = "error";
          break;
      }
      virusCheck.styleClass = "virusCheck" + virusCheckId;
      return virusCheck;
    },
    async download(uploadItem) {
      if (uploadItem.type == "entity") {
        const response = await this.$apollo.query({
          query: UPLOAD_ENTITY_SIGNED_URL,
          variables: { id: uploadItem.id }
        });
        window.open(response.data.uploadEntity.upload.signedUrlGet, "_blank");
      } else if (uploadItem.type == "file") {
        const response = await this.$apollo.query({
          query: UPLOAD_FILE_SIGNED_URL,
          variables: { id: uploadItem.id }
        });
        window.open(response.data.uploadFile.upload.signedUrlGet, "_blank");
      }
    }
  }
};
</script>

<style>
.uploadItemArchived {
  text-decoration: line-through;
}
</style>
